export function addCSS(url) {
  return new Promise((resolve, reject) => {
    var linkElement = document.createElement('link');
    linkElement.rel = 'stylesheet';
    linkElement.type = 'text/css';
    linkElement.href = url;
    linkElement.onload = (val) => {
      resolve(val);
    };
    linkElement.onerror = (err) => {
      reject(err);
    };
    linkElement.onabort = (err) => {
      reject(err);
    };
    document.head.appendChild(linkElement);
  });
}
